import { navigate } from '@reach/router'
import { message } from 'antd'
import Axios, { AxiosRequestConfig } from 'axios'
import { ROOT_PATH, TOKEN_SESSION_KEY } from './config'
import { apiPrefix } from './env'

const env = process.env.NODE_ENV

const configure: AxiosRequestConfig = {
  baseURL: apiPrefix[env],
}

export const api = Axios.create(configure)

api.interceptors.request.use((config) => {
  if (sessionStorage.getItem(TOKEN_SESSION_KEY)) {
    config.headers.Authorization = sessionStorage.getItem(TOKEN_SESSION_KEY)
  }
  return config
})

api.interceptors.response.use(
  (resp) => {
    const { data: payload } = resp

    if (payload.code !== 200) {
      if (payload.code === 401) {
        sessionStorage.clear()
        navigate(ROOT_PATH)
        return
      }
      console.error(resp)
      if (!resp.config.hideMsg) message.error(payload.message)
      throw payload
      // throw Error(payload.message)
    } else {
      if (resp.config.usePayload) return payload
      else return payload.data
    }
  },
  (err) => {
    console.error(err)
    message.error('network error: ' + err.message)
    throw err
  }
)
